import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Recupel = ({ className }: Props) => {
    const { t } = useGranite();
    const { recupel } = useECommerceProduct();

    if (!recupel || recupel <= 0) {
        return null;
    }

    return (
        <div className={cn("tw:text-right", className)}>
            <p className={cn("tw:w-full tw:mb-0 tw:text-xs")}>
                {t("ecommerce.label.recupel-included")}
            </p>
        </div>
    );
};
